import { z } from 'zod';

export const clarifyOptionSchema = z.object({
    headline: z.string(),
    subline: z.string().optional(),
});

export type ClarifyOption = z.infer<typeof clarifyOptionSchema>;

export const clarifyOptionsBlockSchema = z.object({
    blockId: z.uuid(),
    message: z.string(),
    options: z.array(clarifyOptionSchema).min(1),
    type: z.literal('clarify-options'),
});

export type ClarifyOptionsBlock = z.infer<typeof clarifyOptionsBlockSchema>;
